<div>
  <div nxModalContent>
    <h3 nxHeadline="subsection-large" class="nx-margin-bottom-m">
      {{ "COMMON.MODAL.WARNING" | translate }}
    </h3>

    <p nxCopytext="normal" class="nx-margin-bottom-2m nx-font-weight-light">
      {{ message }}
    </p>
  </div>

  <div class="button-container-general">
    <button nxModalClose nxButton="secondary" type="button">
      {{ "GLOBAL.ACTION.CANCEL" | translate | uppercase }}
    </button>
    <button nxModalClose nxButton="primary" type="button" (click)="onclickOK()">
      {{ "GLOBAL.ACTION.PROCEED" | translate | uppercase }}
    </button>
  </div>
</div>
